<div  id="certificate" style="
position: relative;
background-color: #fff;
width: 640px;
height: 480px;
overflow: hidden;
text-align: left;
font-size: 14px;
color: #0e0e0e;
font-family: Nunito;
">
    <img style="
  position: absolute;
  height: 93.33%;
  width: 95.31%;
  top: 3.33%;
  right: 2.34%;
  bottom: 3.33%;
  left: 2.34%;
  max-width: 100%;
  overflow: hidden;
  max-height: 100%;
" alt="" src="assets/certificate/group-1171277863.svg" />

    <div style="
  position: absolute;
  top: 16px;
  left: 15px;
  width: 610px;
  height: 448px;
"></div>
    <div style="
  position: absolute;
  top: 44.04px;
  left: 259.85px;
  width: 120.3px;
  height: 25.77px;
  font-size: 16.62px;
  font-family: Montserrat;
">
        <div style="
    position: absolute;
    top: 3.44px;
    left: 30.3px;
    letter-spacing: 0.65px;
    line-height: 120%;
    font-weight: 600;
  ">
            SwiftChat
        </div>
        <img style="
    position: absolute;
    top: 0px;
    left: 0px;
    width: 25.77px;
    height: 25.77px;
  " alt="" src="assets/certificate/group-130694.svg" />
    </div>
    <div style="
  position: absolute;
  top: 95.81px;
  left: calc(50% - 124px);
  width: 238px;
  height: 90px;
  font-size: 54px;
  color: #1641ba;
  font-family: Courgette;
">
        <div style="
    position: absolute;
    top: 0px;
    left: calc(50% - 119px);
    letter-spacing: -1px;
    line-height: 120%;
  ">
            Certificate
        </div>
        <div style="
    position: absolute;
    top: 61px;
    left: calc(50% - 77px);
    font-size: 24px;
    letter-spacing: -1px;
    line-height: 120%;
  ">
            of Achievement
        </div>
    </div>
    <div style="
  position: relative;
  top: 223.81px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
">
        <div style="
    height: 44px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  ">
            <div style="position: relative; width: 189px; height: 10px">
                <div style="
        position: absolute;
        top: 0px;
        left: calc(50% - 94.5px);
        line-height: 120%;
      ">
                    This certificate is presented to
                </div>
            </div>
            <b style="
      position: relative;
      font-size: 30px;
      line-height: 120%;
      color: #de3647;
      margin-top: 8px;
    ">{{topEntry[certiIndex].user_name}}</b>
        </div>
        <div style="position: relative; line-height: 150%; text-align: center">
            <p style="margin: 0">
                <span style="font-family: Nunito">of {{topEntry[certiIndex].user_grade}} for securing </span>
                <b style="font-family: Nunito">
                    <span *ngIf="certiIndex==0">{{certiIndex+1}}st position</span>
                    <span *ngIf="certiIndex==1">{{certiIndex+1}}nd position</span>
                    <span *ngIf="certiIndex==2">{{certiIndex+1}}rd position</span>
                </b>
                <span style="font-family: Nunito"> in </span>
                <b>{{competitionDetail.title.en}}</b>
            </p>
            <p style="margin: 0">
                <span style="font-family: Nunito">held between </span>
                <b style="font-family: Nunito">{{competitionDetail.start_time | dateTransform: 'std' }}</b>
                <span style="font-family: Nunito"> to </span>
                <b>{{competitionDetail.end_time | dateTransform: 'std' }}</b>
            </p>
        </div>
    </div>
    <div style="
  position: absolute;
  top: 363px;
  left: calc(50% - 54px);
  width: 108px;
  height: 70px;
  overflow: hidden;
  text-align: center;
  font-size: 28px;
  color: #fff;
">
        <div style="
    position: absolute;
    height: 100.09%;
    width: 100.05%;
    top: 0%;
    right: -0.02%;
    bottom: -0.09%;
    left: -0.02%;
  ">
            <img style="
      position: absolute;
      height: 80.59%;
      width: 100%;
      top: 0%;
      right: -0.02%;
      bottom: 19.41%;
      left: 0.02%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
    " alt="" src="assets/certificate/group.svg" />

            <img style="
      position: absolute;
      height: 89.04%;
      width: 51.47%;
      top: 10.96%;
      right: 24.26%;
      bottom: 0%;
      left: 24.26%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
    " alt="" src="assets/certificate/vector.svg" />

            <img style="
      position: absolute;
      height: 89.04%;
      width: 51.47%;
      top: 6.21%;
      right: 24.26%;
      bottom: 4.74%;
      left: 24.26%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
      opacity: 0.8;
    " alt="" src="assets/certificate/vector1.svg" />

            <img style="
      position: absolute;
      height: 89.04%;
      width: 51.47%;
      top: 5.52%;
      right: 24.26%;
      bottom: 5.43%;
      left: 24.26%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
    " alt="" src="assets/certificate/vector2.svg" />

            <img style="
      position: absolute;
      height: 62.56%;
      width: 30.46%;
      top: 5.52%;
      right: 24.35%;
      bottom: 31.92%;
      left: 45.19%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
      opacity: 0.2;
    " alt="" src="assets/certificate/vector3.svg" />

            <img style="
      position: absolute;
      height: 73.17%;
      width: 35.15%;
      top: 21.4%;
      right: 40.6%;
      bottom: 5.43%;
      left: 24.25%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
      opacity: 0.2;
    " alt="" src="assets/certificate/vector4.svg" />

            <img style="
      position: absolute;
      height: 71.01%;
      width: 41.11%;
      top: 15.19%;
      right: 29.44%;
      bottom: 13.8%;
      left: 29.44%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
    " alt="" src="assets/certificate/vector5.svg" />

            <div style="
      position: absolute;
      top: calc(50% - 10.03px);
      left: calc(50% - 9.8px);
      line-height: 120%;
      font-weight: 800;
      display: inline-block;
      width: 19.04px;
      height: 22.07px;
    ">
                {{certiIndex+1}}
            </div>
            <img style="
      position: absolute;
      height: 14.06%;
      width: 38.97%;
      top: 15.19%;
      right: 30.54%;
      bottom: 70.75%;
      left: 30.48%;
      max-width: 100%;
      overflow: hidden;
      max-height: 100%;
    " alt="" src="assets/certificate/vector6.svg" />
        </div>
    </div>
    <div style="
  position: absolute;
  top: 367.68px;
  right: 48.09px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  text-align: center;
">
        <img style="
    position: relative;
    width: 95.62px;
    height: 30px;
    object-fit: cover;
  " alt="" src="assets/certificate/image-1-1@2x.png" />

        <div style="position: relative; line-height: 120%; font-weight: 600">
            Shivangi Jain
        </div>
        <div style="position: relative; font-size: 11px; line-height: 120%">
            <p style="margin: 0">Academic Head ConveGenius</p>
            <p style="margin: 0">& SwiftChat Group</p>
        </div>
    </div>
    <div style="
  position: absolute;
  top: -13.9px;
  left: -14.9px;
  width: 669.8px;
  height: 506.7px;
">
        <header style="
    position: absolute;
    top: 13.9px;
    left: 14.9px;
    border: 15px solid #6fc4cf;
    box-sizing: border-box;
    width: 640px;
    height: 480px;
  "></header>
        <div style="
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 50%;
    background-color: #6fc4cf;
    width: 59.8px;
    height: 59.8px;
  "></div>
        <div style="
    position: absolute;
    top: 446.9px;
    left: 0px;
    border-radius: 50%;
    background-color: #6fc4cf;
    width: 59.8px;
    height: 59.8px;
  "></div>
        <div style="
    position: absolute;
    top: 0px;
    left: 610px;
    border-radius: 50%;
    background-color: #6fc4cf;
    width: 59.8px;
    height: 59.8px;
  "></div>
        <div style="
    position: absolute;
    top: 446.9px;
    left: 610px;
    border-radius: 50%;
    background-color: #6fc4cf;
    width: 59.8px;
    height: 59.8px;
  "></div>
    </div>
</div>